import { render } from "./files.vue?vue&type=template&id=772cbb22"
import script from "./files.vue?vue&type=script&lang=js"
export * from "./files.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/form/field/files.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "772cbb22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('772cbb22', __exports__)) {
    console.log('reload')
    api.reload('772cbb22', __exports__)
  }
  
  module.hot.accept("./files.vue?vue&type=template&id=772cbb22", () => {
    console.log('re-render')
    api.rerender('772cbb22', render)
  })

}


export default __exports__